export default __webpack_public_path__ + "static/media/facebook.839ce7a5.svg";